import { QrReader } from 'react-qr-reader';
import { toast } from 'react-toast';

function Scanner(props) {
    return (
        <>
        <span className="close" onClick={() => props.close()}>&times;</span>
        <div className='scan-corners'>
            <span></span><span></span><span></span><span></span>
        </div>
            <QrReader
                onResult={(result, error) => {
                    if (!error) {
                        props.callback(result, props.eventId);
                        props.close();
                    } else {
                        if(error.message && error.message === 'Permission denied') {
                            props.close();
                            toast.hideAll();
                            toast.error(`We can't find your camera. Check to be sure you have allowed app to access your camera`);
                        }
                    }
                }}
                constraints={{ facingMode: 'environment' }}
                style={{ width: '100%' }}
            />
        </>
    )
}

export default Scanner;